import styled, { keyframes } from 'styled-components'
import { SvgImage } from '~/shared/components/SvgImage'
import { Color } from '~/shared/constants/uiConstants'

const spinKeyframes = keyframes`
  from {
    transform:rotate(0deg);
  }
  to {
    transform:rotate(360deg);
  }
`

export const StyledSpinner = {
  Wrapper: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 12;
    width: 100vw;
    height: var(--full-height, 100vh);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${Color.GRAY_100};
  `,
  Circle: styled(SvgImage)`
    animation-name: ${spinKeyframes};
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  `,
}
